<script>
    import wrappedFetch from "../../wrappedFetch.js";
    import Modal from "../components/modal.svelte";
    import DataTable from "../../components/data-table.svelte";

    export let userDetails;  
    export let ModalConfirmation = false;
    export let NewNote = false;

    let columnDefs =  [{ type: 'date-euro', targets: [1] }];
    let Notes = [];
    
    export async function showAllNotes(){
        let resp = await wrappedFetch('/api/subscriptions/GetCustomerSubscriptionNotes?CustomerID=' + userDetails.customersID, {method: "get"}); 
        Notes = await resp.json();
    }
    
    const ShowNotes=async()=>{
        NewNote = true;
    }

    let CustomerNote = "";
    const handleSaveNotes=async()=>{
        var data = { CustomersID: userDetails.customersID, Notes: CustomerNote }
        let resp = await wrappedFetch(
            `/api/subscriptions/UpdateSubscriptionNotes`,
            {
               method: "post",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        ModalConfirmation = true;
        showAllNotes();
        //handleReset();
    }

    export let exportreset = false;
    const handleReset=async()=> {
        NewNote = false;
        CustomerNote = "";
        ModalConfirmation = false;
        //exportreset = true;
    }
</script>

<div class="row mb-3">
    <div class="col text-right">
        <button class="btn btn-primary" on:click={ShowNotes} >Add new note</button>
    </div>
</div>
<DataTable DataLength={Notes.length} {columnDefs} message="There is currently no notes to this subscription">
    <thead>
        <tr>
            <th width="25%">Date</th>
            <th>Notes</th>
        </tr>
    </thead>
    <tbody>
        {#each Notes as note}
            <tr>
                <td>{note.notesDatestr}</td>
                <td><div style="white-space: pre-line">{note.notes}</div></td>
            </tr>
        {/each}
    </tbody>
</DataTable>


<Modal showModal={NewNote} sizeClass="modal-md" on:close={handleReset}>
    <div slot="header" style="width:100%">
        <div class="row">
            <div class="col">
                <h3 class="text-white">Customer Notes</h3>
            </div>
        </div>
    </div>
    <div slot="content">
        {#if ModalConfirmation}
            <div class="alert alert-success">Your note has successfully been added</div>
        {:else}
        <div class="form-group">
            <textarea class="form-control" rows="10" bind:value={CustomerNote}></textarea>
        </div>
        {/if}
    </div>
    <div slot="footer">
        {#if !ModalConfirmation}
            <button class="btn btn-primary" type="button" on:click={handleSaveNotes}>Add Notes</button>
        {/if}
    </div>
</Modal>   